import Settings from './Settings';
import SettingsContainer from './SettingsContainer';

export { SettingsContainer };
export default Settings;



// WEBPACK FOOTER //
// ./src/components/Settings/index.js